import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mx-auto max-w-7xl px-4 py-8 font-inter" }
const _hoisted_2 = { class: "mb-6 flex items-center gap-2 text-sm font-medium text-gray-600" }
const _hoisted_3 = {
  key: 0,
  class: "space-y-6 animate-pulse"
}
const _hoisted_4 = {
  key: 1,
  class: "grid grid-cols-1 gap-8 lg:grid-cols-3"
}
const _hoisted_5 = { class: "lg:col-span-2 space-y-8" }
const _hoisted_6 = { class: "rounded-lg border border-border bg-card p-6 shadow-sm" }
const _hoisted_7 = { class: "flex flex-col items-center gap-6 text-center sm:flex-row sm:items-start sm:gap-8 sm:text-left" }
const _hoisted_8 = { class: "flex h-24 w-24 shrink-0 items-center justify-center rounded-xl bg-gray-50 p-2 shadow-inner" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "min-w-0 max-w-full" }
const _hoisted_11 = { class: "flex flex-wrap items-center justify-center gap-3 sm:justify-start" }
const _hoisted_12 = { class: "text-3xl font-bold leading-tight text-gray-900" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "mt-2 text-sm font-medium text-gray-700"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "mt-1 text-sm font-medium text-gray-700"
}
const _hoisted_20 = {
  key: 2,
  class: "mt-2 flex max-w-full flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-gray-600 sm:justify-start"
}
const _hoisted_21 = ["href"]
const _hoisted_22 = { class: "truncate" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "truncate" }
const _hoisted_25 = {
  key: 0,
  class: "rounded-lg border border-border bg-card p-6 shadow-sm"
}
const _hoisted_26 = { class: "text-sm leading-relaxed text-gray-600" }
const _hoisted_27 = {
  key: 1,
  class: "rounded-lg border border-border bg-card p-6 shadow-sm"
}
const _hoisted_28 = {
  key: 0,
  class: "mb-5 border-b border-border/60 pb-5"
}
const _hoisted_29 = { class: "flex flex-wrap gap-2" }
const _hoisted_30 = { class: "space-y-4" }
const _hoisted_31 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_32 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_33 = {
  key: 0,
  class: "rounded-full bg-gray-100 px-2.5 py-1 text-xs font-semibold text-gray-700"
}
const _hoisted_34 = {
  key: 0,
  class: "mt-2 text-sm text-gray-600"
}
const _hoisted_35 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_36 = ["onClick"]
const _hoisted_37 = {
  key: 3,
  class: "mt-3 flex flex-wrap gap-2"
}
const _hoisted_38 = {
  key: 4,
  class: "mt-4 border-t border-border/60 pt-3"
}
const _hoisted_39 = { class: "space-y-3" }
const _hoisted_40 = {
  key: 0,
  class: "text-xs font-semibold text-gray-500"
}
const _hoisted_41 = { class: "mt-1" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  key: 2,
  class: "rounded-lg border border-border bg-card p-6 shadow-sm"
}
const _hoisted_44 = { class: "flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between" }
const _hoisted_45 = { class: "text-sm text-gray-600" }
const _hoisted_46 = { class: "inline-flex w-fit items-center rounded-full bg-newPrimary/10 px-3 py-1 text-xs font-semibold text-newPrimary" }
const _hoisted_47 = ["href"]
const _hoisted_48 = { class: "flex items-start justify-between gap-4" }
const _hoisted_49 = { class: "flex h-11 w-11 items-center justify-center rounded-xl border border-white/70 bg-white/80 text-gray-700 shadow-sm" }
const _hoisted_50 = { class: "rounded-full bg-white/80 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-600" }
const _hoisted_51 = { class: "mt-5" }
const _hoisted_52 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_53 = { class: "mt-2 text-sm leading-6 text-gray-600" }
const _hoisted_54 = { class: "mt-5 flex items-center justify-between text-sm font-medium text-gray-700" }
const _hoisted_55 = {
  key: 3,
  class: "rounded-lg border border-border bg-card p-6 shadow-sm"
}
const _hoisted_56 = { class: "flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between" }
const _hoisted_57 = { class: "text-sm text-gray-600" }
const _hoisted_58 = { class: "inline-flex w-fit items-center rounded-full bg-emerald-100 px-3 py-1 text-xs font-semibold text-emerald-700" }
const _hoisted_59 = { class: "mt-5 space-y-4" }
const _hoisted_60 = { class: "flex flex-col gap-4 md:flex-row md:items-start md:justify-between" }
const _hoisted_61 = { class: "min-w-0" }
const _hoisted_62 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_63 = {
  key: 0,
  class: "rounded-full bg-white/90 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-600"
}
const _hoisted_64 = {
  key: 1,
  class: "rounded-full bg-emerald-100 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-emerald-700"
}
const _hoisted_65 = { class: "mt-3 text-base font-semibold text-gray-900" }
const _hoisted_66 = {
  key: 0,
  class: "mt-2 whitespace-pre-line text-sm leading-6 text-gray-600"
}
const _hoisted_67 = { class: "mt-3 flex flex-wrap gap-x-5 gap-y-2 text-sm text-gray-600" }
const _hoisted_68 = {
  key: 0,
  class: "flex items-center gap-1.5"
}
const _hoisted_69 = {
  key: 1,
  class: "flex items-center gap-1.5"
}
const _hoisted_70 = {
  key: 2,
  class: "font-medium text-gray-700"
}
const _hoisted_71 = {
  key: 1,
  class: "mt-4 flex flex-wrap gap-2"
}
const _hoisted_72 = {
  key: 0,
  class: "inline-flex items-center rounded-full border border-emerald-200 bg-white/90 px-3 py-1 text-xs font-medium text-emerald-700"
}
const _hoisted_73 = {
  key: 1,
  class: "inline-flex items-center rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-xs font-medium text-amber-700"
}
const _hoisted_74 = {
  key: 0,
  class: "mt-5 flex items-center justify-between text-sm font-medium text-gray-700"
}
const _hoisted_75 = { class: "space-y-4" }
const _hoisted_76 = { class: "text-lg font-semibold text-gray-900" }
const _hoisted_77 = {
  key: 0,
  class: "grid grid-cols-1 gap-6 md:grid-cols-2"
}
const _hoisted_78 = { class: "text-lg font-semibold text-gray-900" }
const _hoisted_79 = { class: "flex flex-wrap items-center gap-3 text-sm text-gray-600" }
const _hoisted_80 = {
  key: 0,
  class: "flex items-center gap-1"
}
const _hoisted_81 = {
  key: 1,
  class: "rounded-full bg-newPrimary/10 px-2 py-0.5 text-xs font-semibold text-newPrimary"
}
const _hoisted_82 = { class: "text-xs text-gray-500" }
const _hoisted_83 = {
  key: 1,
  class: "rounded-lg border border-border bg-card px-6 py-12 text-center shadow-sm"
}
const _hoisted_84 = { class: "mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100" }
const _hoisted_85 = { class: "lg:col-span-1 space-y-6" }
const _hoisted_86 = { class: "rounded-lg border border-border bg-card p-6 shadow-sm" }
const _hoisted_87 = { class: "mt-4 space-y-4" }
const _hoisted_88 = { key: 0 }
const _hoisted_89 = { class: "font-medium text-gray-800" }
const _hoisted_90 = { class: "mb-2 text-xs text-gray-500" }
const _hoisted_91 = { class: "flex flex-wrap gap-2" }
const _hoisted_92 = { key: 1 }
const _hoisted_93 = { class: "font-medium text-gray-800" }
const _hoisted_94 = { key: 2 }
const _hoisted_95 = { class: "font-medium text-gray-800" }
const _hoisted_96 = { key: 3 }
const _hoisted_97 = { class: "font-medium text-gray-800" }
const _hoisted_98 = { key: 4 }
const _hoisted_99 = { class: "font-medium text-gray-800" }
const _hoisted_100 = { class: "text-xs text-gray-500" }
const _hoisted_101 = { key: 5 }
const _hoisted_102 = { class: "font-medium text-gray-800" }
const _hoisted_103 = { key: 6 }
const _hoisted_104 = { class: "space-y-2" }
const _hoisted_105 = { class: "flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 text-xs font-bold text-gray-600" }
const _hoisted_106 = { class: "text-sm font-medium text-gray-800" }
const _hoisted_107 = { class: "text-xs text-gray-500" }
const _hoisted_108 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_109 = {
  key: 0,
  class: "rounded-lg border border-border bg-card p-6 shadow-sm"
}
const _hoisted_110 = { class: "mt-4 space-y-4" }
const _hoisted_111 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_112 = {
  key: 0,
  class: "text-sm font-semibold text-newPrimary"
}
const _hoisted_113 = {
  key: 1,
  class: "rounded-full bg-gray-100 px-2.5 py-1 text-xs font-semibold text-gray-700"
}
const _hoisted_114 = { class: "mt-3 space-y-3" }
const _hoisted_115 = { class: "min-w-0" }
const _hoisted_116 = {
  key: 0,
  class: "text-base font-semibold text-gray-900"
}
const _hoisted_117 = {
  key: 1,
  class: "mt-1 text-sm leading-relaxed text-gray-600"
}
const _hoisted_118 = ["href"]
const _hoisted_119 = {
  key: 1,
  class: "rounded-lg border border-border bg-card p-6 shadow-sm"
}
const _hoisted_120 = { class: "mt-4 space-y-4" }
const _hoisted_121 = { class: "flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between" }
const _hoisted_122 = { class: "min-w-0" }
const _hoisted_123 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_124 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_125 = {
  key: 0,
  class: "rounded-full bg-gray-100 px-2.5 py-1 text-xs font-semibold text-gray-700"
}
const _hoisted_126 = {
  key: 0,
  class: "mt-1 text-sm font-medium text-gray-700"
}
const _hoisted_127 = {
  key: 1,
  class: "mt-2 text-xs uppercase tracking-[0.14em] text-gray-500"
}
const _hoisted_128 = {
  key: 2,
  class: "mt-2 text-sm leading-relaxed text-gray-600"
}
const _hoisted_129 = ["href"]
const _hoisted_130 = {
  key: 2,
  class: "rounded-lg border border-border bg-card p-6 shadow-sm"
}
const _hoisted_131 = { class: "flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between" }
const _hoisted_132 = { class: "min-w-0 flex-1" }
const _hoisted_133 = { class: "text-sm text-gray-600" }
const _hoisted_134 = { class: "inline-flex w-fit shrink-0 self-start rounded-full bg-amber-100 px-3 py-1 text-xs font-semibold text-amber-700" }
const _hoisted_135 = { class: "mt-5 space-y-4" }
const _hoisted_136 = { class: "space-y-4" }
const _hoisted_137 = { class: "min-w-0" }
const _hoisted_138 = {
  key: 0,
  class: "text-base font-semibold text-gray-900"
}
const _hoisted_139 = {
  key: 1,
  class: "mt-2 text-sm leading-relaxed text-gray-600"
}
const _hoisted_140 = {
  key: 0,
  class: "flex flex-wrap items-center gap-2 border-t border-border/60 pt-3"
}
const _hoisted_141 = {
  key: 0,
  class: "inline-flex rounded-full bg-gray-100 px-2.5 py-1 text-xs font-semibold text-gray-700"
}
const _hoisted_142 = {
  key: 1,
  class: "inline-flex rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-700"
}
const _hoisted_143 = {
  key: 3,
  class: "rounded-lg border border-border bg-card p-6 shadow-sm"
}
const _hoisted_144 = { class: "mt-4 space-y-3" }
const _hoisted_145 = ["href"]
const _hoisted_146 = { class: "min-w-0" }
const _hoisted_147 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_148 = { class: "truncate text-xs text-gray-500" }
const _hoisted_149 = { class: "ml-4 flex shrink-0 items-center gap-2 text-xs font-medium text-newPrimary" }
const _hoisted_150 = {
  key: 4,
  class: "rounded-lg border border-border bg-card p-6 shadow-sm"
}
const _hoisted_151 = { class: "mt-4 space-y-4" }
const _hoisted_152 = { key: 0 }
const _hoisted_153 = { class: "font-medium text-gray-800" }
const _hoisted_154 = { key: 1 }
const _hoisted_155 = { class: "font-medium text-gray-800" }
const _hoisted_156 = { key: 2 }
const _hoisted_157 = { class: "font-medium text-gray-800" }
const _hoisted_158 = { key: 3 }
const _hoisted_159 = { class: "flex flex-wrap gap-2" }
const _hoisted_160 = {
  key: 2,
  class: "rounded-lg border border-border bg-red-50 p-6 text-red-700"
}

import { computed, onMounted, ref, watch } from 'vue'
import { useRoute, RouterLink } from 'vue-router'
import {
  ArrowLeft,
  ArrowUpRight,
  Link,
  Bookmark,
  Building2,
  Briefcase,
  Globe,
  Mail,
  MapPin,
} from 'lucide-vue-next'
import {
  bookmarkContractorCompany,
  getContractorCompanyProfile,
  removeContractorCompanyBookmark,
} from '@/api/contractor/company'
import { formatDateAsDayMonthYear, formatHiringTimeline } from '@/utils/formatters'
import GoogleMap from '@/components/marketplace/generic/GoogleMap.vue'
import { formatMarketCap } from '@/composables/useCompanyMarketData'

type KeyPerson = {
  first_name?: string
  last_name?: string
  role?: string
  role_start_date?: string
  roleStartDate?: string
  name?: string
  position?: string
}

type KeyProject = {
  name: string
  stage: string
  description: string
  location_label: string
  location_lat: number | null
  location_lng: number | null
  commodities: string[]
  activity_feed: Array<{ date: string; text: string }>
}

type TalentPoolSummary = {
  id: number | null
  title: string
  location: string
  type: string
  work_type: number | null
  hiring_timeline?: string | null
  timeline_date: string | null
  timeline?: string | null
}

type JobLinkType = 'linkedin' | 'seek' | 'other'

type CompanyJobLink = {
  type: JobLinkType
  title: string
  description: string
  url: string
}

type RecentCapitalRaising = {
  date: string
  amount: string
  label: string
  summary: string
  url: string
}

type RecentKeyHire = {
  name: string
  role: string
  date: string
  background: string
  summary: string
  url: string
}

type CompanyBenefit = {
  heading: string
  description: string
  source: string
  added_at: string
}

type SocialLinkType = 'linkedin' | 'facebook' | 'instagram' | 'x' | 'youtube'

type CompanySocialLink = {
  type: SocialLinkType
  url: string
}

type CompanyProfile = {
  id: number | null
  name: string
  logo: string
  website: string
  contact_email: string
  summary: string
  industry: string
  industry_attributes: Array<{ key: string; label: string; values: string[] }>
  employee_size: string
  headcount_growth_12_months: string
  average_employee_tenure: string
  head_office: string
  market_cap: number | string | null
  cash_in_bank: number | null
  cash_in_bank_updated_at: string | null
  cash_runway: string
  ticker: string
  is_private_company: boolean
  is_bookmarked: boolean
  key_people: KeyPerson[]
  key_projects: KeyProject[]
  commodities: string[]
  field_roster: string
  typical_hours: string
  facilities: string
  software_used: string[]
  talentPools: TalentPoolSummary[]
  job_links: CompanyJobLink[]
  recent_capital_raisings: RecentCapitalRaising[]
  recent_key_hires: RecentKeyHire[]
  benefits: CompanyBenefit[]
  social_links: CompanySocialLink[]
  manual_jobs: CompanyManualJob[]
}

type CompanyManualJob = {
  id: number | null
  title: string
  summary: string
  location: string
  employment_type: string
  roster: string
  compensation_mode: string
  compensation_amount: string
  compensation_rate_type: string
  date_posted: string
  closing_date: string
  job_url: string
  job_slug: string
  is_imported: boolean
  source_origin: string
  source_label: string
}

type JobLinkDisplayItem = CompanyJobLink & {
  typeLabel: string
  ctaLabel: string
  cardClass: string
  icon: typeof Globe
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyPage',
  setup(__props) {

const route = useRoute()

const company = ref<CompanyProfile | null>(null)
const isLoading = ref(true)
const isBookmarkSaving = ref(false)
const error = ref<string | null>(null)
const expandedProjectDescriptions = ref<Set<number>>(new Set())
const expandedActivityItems = ref<Set<string>>(new Set())
const projectCommodities = computed(() => {
  const projects = company.value?.key_projects ?? []
  return Array.from(
    new Set(
      projects.flatMap((project) =>
        Array.isArray(project.commodities)
          ? project.commodities.map((item) => item.trim()).filter(Boolean)
          : []
      )
    )
  ).sort((a, b) => a.localeCompare(b))
})
const backLinkTarget = computed(() => {
  if (route.query.from === 'jobs') {
    return { name: 'ContractorJobs' }
  }

  return {
    name: 'ContractorCompanySearch',
    query: route.query,
  }
})

onMounted(() => {
  window.scrollTo({ top: 0, behavior: 'auto' })
})

const toSafeString = (value: unknown): string => (typeof value === 'string' ? value.trim() : '')
const shouldShowTextToggle = (value: string): boolean => toSafeString(value).length > 140
const activityKey = (projectIndex: number, activityIndex: number): string => `${projectIndex}:${activityIndex}`

const isProjectDescriptionExpanded = (projectIndex: number): boolean =>
  expandedProjectDescriptions.value.has(projectIndex)

const toggleProjectDescription = (projectIndex: number) => {
  const next = new Set(expandedProjectDescriptions.value)
  if (next.has(projectIndex)) {
    next.delete(projectIndex)
  } else {
    next.add(projectIndex)
  }
  expandedProjectDescriptions.value = next
}

const isActivityExpanded = (projectIndex: number, activityIndex: number): boolean =>
  expandedActivityItems.value.has(activityKey(projectIndex, activityIndex))

const toggleActivity = (projectIndex: number, activityIndex: number) => {
  const key = activityKey(projectIndex, activityIndex)
  const next = new Set(expandedActivityItems.value)
  if (next.has(key)) {
    next.delete(key)
  } else {
    next.add(key)
  }
  expandedActivityItems.value = next
}

const parseMoney = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null
  if (typeof value === 'number') return Number.isFinite(value) ? value : null
  if (typeof value === 'string') {
    const filtered = value.replace(/[^0-9.]/g, '')
    const parsed = Number(filtered)
    return Number.isFinite(parsed) ? parsed : null
  }
  return null
}
const parseCoordinate = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') return null
  const parsed = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

const formatDateLabel = (value: unknown): string | null => {
  if (typeof value !== 'string' || !value.trim()) return null
  const parsed = new Date(value)
  if (Number.isNaN(parsed.getTime())) {
    return value
  }

  return parsed.toLocaleDateString()
}

const normalizeJobLinks = (value: unknown): CompanyJobLink[] => {
  if (!Array.isArray(value)) return []

  return value
    .map((entry) => {
      if (!entry || typeof entry !== 'object') return null

      const type = toSafeString((entry as any).type).toLowerCase() as JobLinkType
      if (!['linkedin', 'seek', 'other'].includes(type)) return null

      const url = toSafeString((entry as any).url ?? '')
      if (!url) return null

      return {
        type,
        title: toSafeString((entry as any).title ?? ''),
        description: toSafeString((entry as any).description ?? ''),
        url,
      }
    })
    .filter((entry): entry is CompanyJobLink => Boolean(entry))
}

const normalizeSocialLinks = (value: unknown): CompanySocialLink[] => {
  if (!Array.isArray(value)) return []

  return value
    .map((entry) => {
      if (!entry || typeof entry !== 'object') return null

      const type = toSafeString((entry as any).type).toLowerCase() as SocialLinkType
      if (!['linkedin', 'facebook', 'instagram', 'x', 'youtube'].includes(type)) return null

      const url = toSafeString((entry as any).url ?? '')
      if (!url) return null

      return { type, url }
    })
    .filter((entry): entry is CompanySocialLink => Boolean(entry))
}

const normalizeRecentKeyHires = (value: unknown): RecentKeyHire[] => {
  if (!Array.isArray(value)) return []

  return value
    .map((entry) => {
      if (!entry || typeof entry !== 'object') return null

      const item = {
        name: toSafeString((entry as any).name ?? ''),
        role: toSafeString((entry as any).role ?? (entry as any).title ?? ''),
        date: toSafeString((entry as any).date ?? ''),
        background: toSafeString((entry as any).background ?? ''),
        summary: toSafeString((entry as any).summary ?? ''),
        url: toSafeString((entry as any).url ?? ''),
      }

      return item.name || item.role || item.date || item.background || item.summary || item.url
        ? item
        : null
    })
    .filter((entry): entry is RecentKeyHire => Boolean(entry))
}

const normalizeRecentCapitalRaisings = (value: unknown): RecentCapitalRaising[] => {
  if (!Array.isArray(value)) return []

  return value
    .map((entry) => {
      if (!entry || typeof entry !== 'object') return null

      const item = {
        date: toSafeString((entry as any).date ?? ''),
        amount: toSafeString((entry as any).amount ?? ''),
        label: toSafeString((entry as any).label ?? (entry as any).type ?? ''),
        summary: toSafeString((entry as any).summary ?? (entry as any).notes ?? ''),
        url: toSafeString((entry as any).url ?? ''),
      }

      return item.date || item.amount || item.label || item.summary || item.url ? item : null
    })
    .filter((entry): entry is RecentCapitalRaising => Boolean(entry))
}

const normalizeBenefits = (value: unknown): CompanyBenefit[] => {
  if (!Array.isArray(value)) return []

  return value
    .map((entry) => {
      if (!entry || typeof entry !== 'object') return null

      const item = {
        heading: toSafeString((entry as any).heading ?? (entry as any).title ?? ''),
        description: toSafeString((entry as any).description ?? (entry as any).summary ?? ''),
        source: toSafeString((entry as any).source ?? ''),
        added_at: toSafeString((entry as any).added_at ?? (entry as any).date ?? ''),
      }

      return item.heading || item.description || item.source ? item : null
    })
    .filter((entry): entry is CompanyBenefit => Boolean(entry))
}

const normalizeExternalUrl = (value: string): string =>
  /^https?:\/\//i.test(value) ? value : `https://${value}`

const normalizeCompanyPayload = (payload: any): CompanyProfile => {
  const normalizePeople = Array.isArray(payload.key_people)
    ? payload.key_people.map((person: any) => ({
      ...person,
      first_name: toSafeString(person?.first_name ?? person?.firstName ?? ''),
      last_name: toSafeString(person?.last_name ?? person?.lastName ?? ''),
      role: toSafeString(person?.role ?? person?.position ?? ''),
      role_start_date: toSafeString(person?.role_start_date ?? person?.roleStartDate ?? ''),
    }))
    : []
  const normalizeCommodities = Array.isArray(payload.commodities) ? payload.commodities : []
  const normalizeSoftware = Array.isArray(payload.software_used) ? payload.software_used : []
  const normalizeProjects = Array.isArray(payload.key_projects) ? payload.key_projects : []
  const normalizedJobLinks = normalizeJobLinks(payload.job_links ?? payload.jobLinks ?? [])
  const normalizedRecentKeyHires = normalizeRecentKeyHires(payload.recent_key_hires)
  const normalizedSocialLinks = normalizeSocialLinks(payload.social_links)
  const normalizedRecentCapitalRaisings = normalizeRecentCapitalRaisings(payload.recent_capital_raisings)
  const normalizedBenefits = normalizeBenefits(payload.benefits)
  const manualJobsSource = Array.isArray(payload.manual_jobs) ? payload.manual_jobs : []
  const poolsRawSource = payload.talent_pools ?? payload.talentPools ?? []

  const poolsArray = (() => {
    if (Array.isArray(poolsRawSource)) return poolsRawSource
    if (poolsRawSource && typeof poolsRawSource === 'object') return Object.values(poolsRawSource)
    return []
  })()

  const talentPools: TalentPoolSummary[] = poolsArray.map((pool: any) => ({
    id: pool.id !== undefined ? Number(pool.id) : null,
    title: toSafeString(pool.title ?? ''),
    location: toSafeString(pool.location ?? ''),
    type: toSafeString(pool.type ?? ''),
    work_type: pool.work_type !== undefined && pool.work_type !== null ? Number(pool.work_type) : null,
    hiring_timeline: pool.hiring_timeline ?? null,
    timeline_date: formatDateLabel(pool.timeline_date ?? pool.timeline),
    timeline: pool.timeline ?? null,
  }))

  const rawMarketCap = payload.market_cap
  const rawMarketCapText = typeof rawMarketCap === 'string' ? rawMarketCap.trim() : ''
  const numericMarketCap = rawMarketCap !== null && rawMarketCap !== undefined && rawMarketCapText.toUpperCase() !== 'SUSPENDED'
    ? Number(rawMarketCap)
    : null
  const marketCap = rawMarketCapText.toUpperCase() === 'SUSPENDED'
    ? 'SUSPENDED'
    : (Number.isFinite(numericMarketCap) ? numericMarketCap : null)
  const cashInBank = parseMoney(payload.cash_in_bank ?? null)

  return {
    id: payload.id !== undefined ? Number(payload.id) : null,
    name: toSafeString(payload.name ?? ''),
    logo: toSafeString(payload.logo ?? ''),
    website: toSafeString(payload.website ?? ''),
    contact_email: toSafeString(payload.contact_email ?? payload.contactEmail ?? ''),
    summary: toSafeString(payload.summary ?? ''),
    industry: toSafeString(payload.industry ?? ''),
    industry_attributes: Array.isArray(payload.industry_attributes)
      ? payload.industry_attributes.filter(
          (group: any) => group && typeof group.label === 'string' && Array.isArray(group.values) && group.values.length
        )
      : [],
    employee_size: toSafeString(payload.employee_size ?? ''),
    headcount_growth_12_months: toSafeString(payload.headcount_growth_12_months ?? ''),
    average_employee_tenure: toSafeString(payload.average_employee_tenure ?? ''),
    head_office: toSafeString(payload.head_office ?? payload.office_address ?? ''),
    market_cap: marketCap,
    cash_in_bank: Number.isFinite(cashInBank ?? NaN) ? cashInBank : null,
    cash_in_bank_updated_at: toSafeString(payload.cash_in_bank_updated_at ?? '') || null,
    cash_runway: toSafeString(payload.cash_runway ?? ''),
    ticker: toSafeString(payload.ticker ?? ''),
    is_private_company: Boolean(payload.is_private_company),
    is_bookmarked: Boolean(payload.is_bookmarked),
    key_people: normalizePeople,
    key_projects: normalizeProjects.map((project: any) => ({
      name: toSafeString(project?.name ?? ''),
      stage: toSafeString(project?.stage ?? ''),
      description: toSafeString(project?.description ?? ''),
      location_label: toSafeString(project?.location_label ?? project?.locationLabel ?? project?.location ?? ''),
      location_lat: parseCoordinate(project?.location_lat ?? project?.locationLat ?? project?.lat),
      location_lng: parseCoordinate(project?.location_lng ?? project?.locationLng ?? project?.lng ?? project?.lon),
      commodities: Array.isArray(project?.commodities)
        ? project.commodities.map((item: string) => item.trim()).filter(Boolean)
        : [],
      activity_feed: Array.isArray(project?.activity_feed ?? project?.activityFeed)
        ? (project.activity_feed ?? project.activityFeed)
            .map((activity: any) => ({
              date: toSafeString(activity?.date ?? activity?.released_at ?? activity?.releasedAt ?? ''),
              text: toSafeString(activity?.text ?? activity?.update ?? activity?.description ?? ''),
            }))
            .filter((activity: { date: string; text: string }) => activity.date || activity.text)
            .sort((a: { date: string }, b: { date: string }) => b.date.localeCompare(a.date))
        : [],
    })),
    commodities: normalizeCommodities.map((item: string) => item.trim()).filter(Boolean),
    field_roster: toSafeString(payload.field_roster ?? ''),
    typical_hours: toSafeString(payload.typical_hours ?? ''),
    facilities: toSafeString(payload.facilities ?? ''),
    software_used: normalizeSoftware.map((item: string) => item.trim()).filter(Boolean),
    talentPools,
    job_links: normalizedJobLinks,
    recent_capital_raisings: normalizedRecentCapitalRaisings,
    recent_key_hires: normalizedRecentKeyHires,
    benefits: normalizedBenefits,
    social_links: normalizedSocialLinks,
    manual_jobs: manualJobsSource
      .map((job: any) => ({
        id: job.id !== undefined && job.id !== null ? Number(job.id) : null,
        title: toSafeString(job.title ?? ''),
        summary: toSafeString(job.summary ?? ''),
        location: toSafeString(job.location ?? ''),
        employment_type: toSafeString(job.employment_type ?? ''),
        roster: toSafeString(job.roster ?? ''),
        compensation_mode: toSafeString(job.compensation_mode ?? ''),
        compensation_amount: toSafeString(job.compensation_amount ?? ''),
        compensation_rate_type: toSafeString(job.compensation_rate_type ?? ''),
        date_posted: toSafeString(job.date_posted ?? ''),
        closing_date: toSafeString(job.closing_date ?? ''),
        job_url: toSafeString(job.job_url ?? ''),
        job_slug: toSafeString(job.job_slug ?? ''),
        is_imported: Boolean(job.is_imported),
        source_origin: toSafeString(job.source_origin ?? ''),
        source_label: toSafeString(job.source_label ?? ''),
      }))
      .filter((job: CompanyManualJob) => Boolean(job.title)),
  }
}


const fetchCompany = async () => {
  const slug = route.params.slug as string | undefined
  if (!slug) {
    error.value = 'Missing company identifier.'
    isLoading.value = false
    return
  }

  isLoading.value = true
  error.value = null

  try {
    const { data } = await getContractorCompanyProfile(slug)
    company.value = normalizeCompanyPayload(data)
  } catch (err: any) {
    console.error('Failed to load company', err)
    error.value = err?.response?.data?.error ?? 'Failed to load company information.'
    company.value = null
  } finally {
    isLoading.value = false
  }
}

const toggleCompanyBookmark = async () => {
  if (!company.value?.id || isBookmarkSaving.value) return

  const companyId = company.value.id
  const previousBookmarkedState = company.value.is_bookmarked
  const nextBookmarkedState = !company.value.is_bookmarked
  isBookmarkSaving.value = true
  company.value = {
    ...company.value,
    is_bookmarked: nextBookmarkedState,
  }

  try {
    if (nextBookmarkedState) {
      await bookmarkContractorCompany(companyId)
    } else {
      await removeContractorCompanyBookmark(companyId)
    }
  } catch (error) {
    console.error('Failed to update company bookmark', error)
    if (company.value?.id === companyId) {
      company.value = {
        ...company.value,
        is_bookmarked: previousBookmarkedState,
      }
    }
  } finally {
    isBookmarkSaving.value = false
  }
}

watch(
  () => route.params.slug,
  () => {
    fetchCompany()
  },
  { immediate: true }
)

const formattedMarketCap = computed<number | string | null>(() => {
  if (!company.value?.market_cap) return null
  if (company.value.market_cap === 'SUSPENDED') return company.value.market_cap
  return Number.isFinite(company.value.market_cap) ? company.value.market_cap : null
})

const formatAudCurrency = (value: number | null): string => {
  if (value === null || !Number.isFinite(value)) return ''
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    maximumFractionDigits: 0,
  }).format(value)
}

const formatCapitalRaisingAmount = (value: unknown): string => {
  const amount = toSafeString(value)
  if (!amount || !/\d/.test(amount) || /^(?:aud|a\$)/i.test(amount) || amount.includes('$')) {
    return amount
  }

  return `$${amount}`
}

const formatCashRunway = (value: unknown): string => {
  const amount = toSafeString(value)
  if (!amount) return ''
  if (/[a-z]/i.test(amount)) return amount

  const numericAmount = Number(amount)
  if (!Number.isFinite(numericAmount)) return amount

  return `${amount} ${numericAmount === 1 ? 'quarter' : 'quarters'}`
}

const formatPercentValue = (value: unknown): string => {
  const text = toSafeString(value)
  if (!text) return ''
  return text.includes('%') ? text : `${text}%`
}

const formatYearsValue = (value: unknown): string => {
  const text = toSafeString(value)
  if (!text) return ''
  return /\b(year|years|yr|yrs|month|months|mo|mos)\b/i.test(text) ? text : `${text} years`
}

const formattedMarketCapLabel = computed(() => {
  if (formattedMarketCap.value === null) return ''
  return formatMarketCap(formattedMarketCap.value)
})

const cashInBankLabel = computed(() => formatAudCurrency(company.value?.cash_in_bank ?? null))

const cashRunwayLabel = computed(() => formatCashRunway(company.value?.cash_runway ?? ''))

const cashInBankDateLabel = computed(() => {
  const raw = company.value?.cash_in_bank_updated_at
  if (!raw) return ''
  return formatDateAsDayMonthYear(raw)
})

const showMarketCap = computed(
  () =>
    formattedMarketCap.value !== null &&
    !!company.value?.ticker &&
    !company.value?.is_private_company
)

const displayWebsite = computed(() => {
  const raw = company.value?.website
  if (!raw) return ''
  return raw.replace(/^https?:\/\//i, '')
})

const websiteHref = computed(() => {
  const raw = company.value?.website
  if (!raw) return ''
  return /^https?:\/\//i.test(raw) ? raw : `https://${raw}`
})

const contactEmailHref = computed(() => {
  const raw = company.value?.contact_email
  if (!raw) return ''
  return `mailto:${raw}`
})

const socialLinkDisplayItems = computed(() => {
  const links = Array.isArray(company.value?.social_links) ? company.value.social_links : []

  return links.map((socialLink) => {
    const labelMap: Record<SocialLinkType, string> = {
      linkedin: 'LinkedIn',
      facebook: 'Facebook',
      instagram: 'Instagram',
      x: 'X',
      youtube: 'YouTube',
    }

    return {
      ...socialLink,
      label: labelMap[socialLink.type],
      displayUrl: normalizeExternalUrl(socialLink.url).replace(/^https?:\/\//i, ''),
    }
  })
})

const companyJobLinks = computed<JobLinkDisplayItem[]>(() => {
  const links = Array.isArray(company.value?.job_links) ? company.value.job_links : []

  return links.map((jobLink) => {
    if (jobLink.type === 'linkedin') {
      return {
        ...jobLink,
        typeLabel: 'LinkedIn',
        ctaLabel: 'View on LinkedIn',
        cardClass: 'from-sky-50 via-white to-blue-50',
        icon: Briefcase,
      }
    }

    if (jobLink.type === 'seek') {
      return {
        ...jobLink,
        typeLabel: 'Seek',
        ctaLabel: 'View on SEEK',
        cardClass: 'from-rose-50 via-white to-orange-50',
        icon: Globe,
      }
    }

    return {
      ...jobLink,
      typeLabel: 'Other',
      ctaLabel: 'Open careers page',
      cardClass: 'from-emerald-50 via-white to-teal-50',
      icon: Building2,
    }
  })
})

const operationsVisible = computed(() => {
  if (!company.value) return false
  return Boolean(
    company.value.field_roster ||
      company.value.typical_hours ||
      company.value.facilities ||
      company.value.software_used.length
  )
})

const personName = (person: KeyPerson = {}): string => {
  const first = toSafeString(person.first_name ?? person.name?.split(' ')[0] ?? '')
  const last = toSafeString(person.last_name ?? person.name?.split(' ').slice(1).join(' ') ?? '')
  const legacy = toSafeString(person.name ?? '')
  const combined = `${first} ${last}`.trim()
  return combined || legacy || '—'
}

const personRole = (person: KeyPerson = {}): string =>
  toSafeString(person.role ?? person.position ?? '')

const personRoleTenure = (person: KeyPerson = {}): string => {
  const raw = toSafeString(person.role_start_date ?? person.roleStartDate ?? '')
  if (!raw) return ''

  const start = new Date(`${raw.slice(0, 10)}T00:00:00`)
  if (Number.isNaN(start.getTime())) return ''

  const now = new Date()
  if (start > now) return ''

  let months = (now.getFullYear() - start.getFullYear()) * 12 + (now.getMonth() - start.getMonth())
  if (now.getDate() < start.getDate()) months -= 1
  months = Math.max(months, 0)

  const years = Math.floor(months / 12)
  const remainingMonths = months % 12
  const parts = []

  if (years > 0) parts.push(`${years} ${years === 1 ? 'year' : 'years'}`)
  if (remainingMonths > 0) parts.push(`${remainingMonths} ${remainingMonths === 1 ? 'month' : 'months'}`)

  return parts.length ? parts.join(' ') : 'Less than 1 month'
}

const personInitial = (person: KeyPerson = {}): string => {
  const name = personName(person)
  return name ? name.charAt(0).toUpperCase() : '?'
}

const formatCompensation = (job: CompanyManualJob): string => {
  const amount = Number(job.compensation_amount)
  if (Number.isFinite(amount) && amount > 0) {
    const formatted = new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      maximumFractionDigits: 0,
    }).format(amount)

    if (job.compensation_mode === 'salary') {
      return formatted
    }

    if (job.compensation_mode === 'rate' && job.compensation_rate_type) {
      const labelMap: Record<string, string> = {
        hour: 'hour',
        day: 'day',
        month: 'month',
      }

      return `${formatted} / ${labelMap[job.compensation_rate_type] ?? job.compensation_rate_type}`
    }
  }

  return ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(RouterLink), {
        to: backLinkTarget.value,
        class: "inline-flex items-center gap-2 hover:text-newPrimary"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ArrowLeft), { class: "h-4 w-4" }),
          _cache[0] || (_cache[0] = _createTextVNode(" Back "))
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[1] || (_cache[1] = [
          _createStaticVNode("<div class=\"grid grid-cols-1 lg:grid-cols-3 gap-8\"><div class=\"lg:col-span-2 space-y-6\"><div class=\"rounded-lg border border-border bg-card p-6\"><div class=\"mb-4 h-6 w-40 rounded bg-muted\"></div><div class=\"flex items-center gap-6\"><div class=\"h-20 w-20 rounded-md bg-muted\"></div><div class=\"flex-1 space-y-2\"><div class=\"h-6 w-1/2 rounded bg-muted\"></div><div class=\"h-4 w-1/3 rounded bg-muted\"></div></div></div></div><div class=\"rounded-lg border border-border bg-card p-6 space-y-3\"><div class=\"h-5 w-32 rounded bg-muted\"></div><div class=\"h-3 w-full rounded bg-muted\"></div><div class=\"h-3 w-5/6 rounded bg-muted\"></div><div class=\"h-3 w-4/6 rounded bg-muted\"></div></div><div class=\"rounded-lg border border-border bg-card p-6 space-y-4\"><div class=\"h-5 w-48 rounded bg-muted\"></div><div class=\"grid grid-cols-1 md:grid-cols-2 gap-4\"><div class=\"h-20 rounded bg-muted\"></div><div class=\"h-20 rounded bg-muted\"></div></div></div></div><div class=\"lg:col-span-1 space-y-6\"><div class=\"rounded-lg border border-border bg-card p-6 space-y-3\"><div class=\"h-5 w-36 rounded bg-muted\"></div><div class=\"h-3 w-full rounded bg-muted\"></div><div class=\"h-3 w-5/6 rounded bg-muted\"></div><div class=\"h-3 w-4/6 rounded bg-muted\"></div></div><div class=\"rounded-lg border border-border bg-card p-6 space-y-3\"><div class=\"h-5 w-40 rounded bg-muted\"></div><div class=\"h-3 w-full rounded bg-muted\"></div><div class=\"h-3 w-5/6 rounded bg-muted\"></div><div class=\"h-3 w-4/6 rounded bg-muted\"></div></div></div></div>", 1)
        ])))
      : (company.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    (company.value.logo)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: company.value.logo,
                          alt: "Company logo",
                          class: "max-h-20 max-w-full object-contain"
                        }, null, 8, _hoisted_9))
                      : (_openBlock(), _createBlock(_unref(Building2), {
                          key: 1,
                          class: "h-10 w-10 text-gray-300"
                        }))
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("h1", _hoisted_12, _toDisplayString(company.value.name), 1),
                      (company.value.id)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: _normalizeClass(["inline-flex h-10 items-center gap-2 rounded-lg border px-3 text-sm font-semibold transition focus:outline-none focus:ring-2 focus:ring-newPrimary/20 disabled:cursor-not-allowed disabled:opacity-60", company.value.is_bookmarked
                    ? 'border-newPrimary bg-newPrimary text-white hover:bg-newPrimary/90'
                    : 'border-gray-300 bg-white text-gray-700 hover:border-newPrimary hover:text-newPrimary']),
                            disabled: isBookmarkSaving.value,
                            onClick: toggleCompanyBookmark
                          }, [
                            _createVNode(_unref(Bookmark), {
                              class: _normalizeClass(["h-4 w-4", { 'fill-current': company.value.is_bookmarked }])
                            }, null, 8, ["class"]),
                            _createTextVNode(" " + _toDisplayString(company.value.is_bookmarked ? 'Bookmarked' : 'Bookmark'), 1)
                          ], 10, _hoisted_13))
                        : _createCommentVNode("", true)
                    ]),
                    (showMarketCap.value || company.value.is_private_company || company.value.ticker)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                          (showMarketCap.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(formattedMarketCapLabel.value) + " Market Cap", 1))
                            : (company.value.is_private_company)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Private company"))
                              : _createCommentVNode("", true),
                          (company.value.ticker)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                (showMarketCap.value || company.value.is_private_company)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, " · "))
                                  : _createCommentVNode("", true),
                                _createTextVNode("ASX:" + _toDisplayString(company.value.ticker), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (company.value.head_office)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(company.value.head_office), 1))
                      : _createCommentVNode("", true),
                    ((websiteHref.value && displayWebsite.value) || contactEmailHref.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          (websiteHref.value && displayWebsite.value)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                href: websiteHref.value,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                class: "inline-flex max-w-full min-w-0 items-center gap-1.5 hover:text-newPrimary"
                              }, [
                                _createVNode(_unref(Link), { class: "h-4 w-4 shrink-0" }),
                                _createElementVNode("span", _hoisted_22, _toDisplayString(displayWebsite.value), 1)
                              ], 8, _hoisted_21))
                            : _createCommentVNode("", true),
                          (contactEmailHref.value)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                href: contactEmailHref.value,
                                class: "inline-flex max-w-full min-w-0 items-center gap-1.5 hover:text-newPrimary"
                              }, [
                                _createVNode(_unref(Mail), { class: "h-4 w-4 shrink-0" }),
                                _createElementVNode("span", _hoisted_24, _toDisplayString(company.value.contact_email), 1)
                              ], 8, _hoisted_23))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (company.value.summary)
                ? (_openBlock(), _createElementBlock("section", _hoisted_25, [
                    _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "mb-2 text-lg font-semibold text-gray-900" }, " About Us ", -1)),
                    _createElementVNode("p", _hoisted_26, _toDisplayString(company.value.summary), 1)
                  ]))
                : _createCommentVNode("", true),
              (company.value.key_projects.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_27, [
                    _cache[5] || (_cache[5] = _createElementVNode("h3", { class: "mb-4 text-lg font-semibold text-gray-900" }, "Key Projects", -1)),
                    (projectCommodities.value.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "mb-2 text-sm font-semibold text-gray-900" }, "Commodities Across Projects", -1)),
                          _createElementVNode("div", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(projectCommodities.value, (item) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: item,
                                class: "rounded-full bg-newPrimary/10 px-2.5 py-1 text-xs font-semibold text-newPrimary"
                              }, _toDisplayString(item), 1))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(company.value.key_projects, (project, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "rounded-lg border border-border/60 bg-background/80 p-4"
                        }, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("span", _hoisted_32, _toDisplayString(project.name || 'Untitled project'), 1),
                            (project.stage)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(project.stage), 1))
                              : _createCommentVNode("", true)
                          ]),
                          (project.location_label)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(project.location_label), 1))
                            : _createCommentVNode("", true),
                          (project.description)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("p", {
                                  class: _normalizeClass(["text-sm leading-relaxed text-gray-600", { 'line-clamp-2': !isProjectDescriptionExpanded(index) }])
                                }, _toDisplayString(project.description), 3),
                                (shouldShowTextToggle(project.description))
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "mt-1 text-xs font-medium text-newPrimary hover:underline",
                                      onClick: ($event: any) => (toggleProjectDescription(index))
                                    }, _toDisplayString(isProjectDescriptionExpanded(index) ? 'Show less' : 'Read more'), 9, _hoisted_36))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (project.location_label || project.location_lat || project.location_lng)
                            ? (_openBlock(), _createBlock(GoogleMap, {
                                key: 2,
                                class: "mt-3",
                                address: project.location_label,
                                lat: project.location_lat ?? null,
                                lng: project.location_lng ?? null,
                                "map-height-class": "h-40",
                                zoom: 7
                              }, null, 8, ["address", "lat", "lng"]))
                            : _createCommentVNode("", true),
                          (project.commodities.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.commodities, (item) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: item,
                                    class: "rounded-full bg-newPrimary/10 px-2.5 py-1 text-xs font-semibold text-newPrimary"
                                  }, _toDisplayString(item), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          (project.activity_feed.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mb-2 text-xs font-semibold uppercase tracking-wide text-gray-500" }, "Activity Feed", -1)),
                                _createElementVNode("div", _hoisted_39, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.activity_feed, (activity, activityIndex) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: `${activity.date}-${activityIndex}`,
                                      class: "text-sm"
                                    }, [
                                      (activity.date)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_unref(formatDateAsDayMonthYear)(activity.date)), 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_41, [
                                        _createElementVNode("p", {
                                          class: _normalizeClass(["leading-relaxed text-gray-700", { 'line-clamp-2': !isActivityExpanded(index, activityIndex) }])
                                        }, _toDisplayString(activity.text), 3),
                                        (shouldShowTextToggle(activity.text))
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              type: "button",
                                              class: "mt-1 text-xs font-medium text-newPrimary hover:underline",
                                              onClick: ($event: any) => (toggleActivity(index, activityIndex))
                                            }, _toDisplayString(isActivityExpanded(index, activityIndex) ? 'Show less' : 'Read more'), 9, _hoisted_42))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (companyJobLinks.value.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("div", null, [
                        _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900" }, "Current Job Opportunities", -1)),
                        _createElementVNode("p", _hoisted_45, " Explore active hiring pages and career destinations for " + _toDisplayString(company.value.name) + ". ", 1)
                      ]),
                      _createElementVNode("span", _hoisted_46, _toDisplayString(companyJobLinks.value.length) + " live " + _toDisplayString(companyJobLinks.value.length === 1 ? 'link' : 'links'), 1)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["mt-5 grid grid-cols-1 gap-4", {
              'md:grid-cols-2': companyJobLinks.value.length === 2,
              'md:grid-cols-3': companyJobLinks.value.length >= 3,
            }])
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(companyJobLinks.value, (jobLink) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: `${jobLink.type}-${jobLink.url}`,
                          href: jobLink.url,
                          target: "_blank",
                          rel: "noopener noreferrer",
                          class: _normalizeClass(["group rounded-xl border border-border/70 bg-gradient-to-br p-5 shadow-sm transition hover:-translate-y-0.5 hover:border-newPrimary/40 hover:shadow-md", jobLink.cardClass])
                        }, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(jobLink.icon), { class: "h-5 w-5" }))
                            ]),
                            _createElementVNode("span", _hoisted_50, _toDisplayString(jobLink.typeLabel), 1)
                          ]),
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("h4", _hoisted_52, _toDisplayString(jobLink.title), 1),
                            _createElementVNode("p", _hoisted_53, _toDisplayString(jobLink.description), 1)
                          ]),
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("span", null, _toDisplayString(jobLink.ctaLabel), 1),
                            _createVNode(_unref(ArrowUpRight), { class: "h-4 w-4 transition group-hover:translate-x-0.5 group-hover:-translate-y-0.5" })
                          ])
                        ], 10, _hoisted_47))
                      }), 128))
                    ], 2)
                  ]))
                : _createCommentVNode("", true),
              (company.value.manual_jobs.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("div", null, [
                        _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900" }, "Live Jobs", -1)),
                        _createElementVNode("p", _hoisted_57, " Current opportunities from " + _toDisplayString(company.value.name) + "'s hiring channels — view roles and go straight to the source to apply. ", 1)
                      ]),
                      _createElementVNode("span", _hoisted_58, _toDisplayString(company.value.manual_jobs.length) + " job" + _toDisplayString(company.value.manual_jobs.length === 1 ? '' : 's'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(company.value.manual_jobs, (job) => {
                        return (_openBlock(), _createBlock(_resolveDynamicComponent(job.is_imported ? _unref(RouterLink) : 'a'), {
                          key: job.id ?? `${job.title}-${job.job_url}`,
                          to: job.is_imported && job.job_slug ? `/contractor/job/${job.job_slug}` : undefined,
                          href: !job.is_imported ? (job.job_url || undefined) : undefined,
                          target: !job.is_imported && job.job_url ? '_blank' : undefined,
                          rel: !job.is_imported && job.job_url ? 'noopener noreferrer' : undefined,
                          class: _normalizeClass(["group block rounded-xl border border-border/70 bg-gradient-to-br from-emerald-50 via-white to-teal-50 p-5 shadow-sm transition hover:-translate-y-0.5 hover:border-emerald-300/70 hover:shadow-md", { 'pointer-events-none': job.is_imported ? !job.job_slug : !job.job_url }])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _createElementVNode("div", _hoisted_62, [
                                  (job.employment_type)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_63, _toDisplayString(job.employment_type), 1))
                                    : _createCommentVNode("", true),
                                  (job.source_label)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(job.source_label), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("h4", _hoisted_65, _toDisplayString(job.title), 1),
                                (job.summary)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString(job.summary), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_67, [
                                  (job.location)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_68, [
                                        _createVNode(_unref(MapPin), { class: "h-4 w-4 text-emerald-600" }),
                                        _createTextVNode(" " + _toDisplayString(job.location), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (job.roster)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_69, [
                                        _createVNode(_unref(Briefcase), { class: "h-4 w-4 text-emerald-600" }),
                                        _createTextVNode(" " + _toDisplayString(job.roster) + " roster ", 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (formatCompensation(job))
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(formatCompensation(job)), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                (job.date_posted || job.closing_date)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                      (job.date_posted)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_72, " Posted " + _toDisplayString(_unref(formatDateAsDayMonthYear)(job.date_posted)), 1))
                                        : _createCommentVNode("", true),
                                      (job.closing_date)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_73, " Closes " + _toDisplayString(_unref(formatDateAsDayMonthYear)(job.closing_date)), 1))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            (job.job_url || job.job_slug)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                  _createElementVNode("span", null, _toDisplayString(job.is_imported ? 'View full job' : 'Open job posting'), 1),
                                  _createVNode(_unref(ArrowUpRight), { class: "h-4 w-4 transition group-hover:translate-x-0.5 group-hover:-translate-y-0.5" })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["to", "href", "target", "rel", "class"]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("section", _hoisted_75, [
                _createElementVNode("h3", _hoisted_76, " Open Talent Pools at " + _toDisplayString(company.value.name), 1),
                (company.value.talentPools.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(company.value.talentPools, (pool) => {
                        return (_openBlock(), _createBlock(_resolveDynamicComponent(pool.id ? _unref(RouterLink) : 'div'), {
                          key: pool.id ?? pool.title,
                          to: pool.id ? { name: 'TalentCommunityDetail', params: { id: pool.id } } : undefined,
                          class: "flex flex-col gap-2 rounded-lg border border-border bg-card p-5 shadow-sm transition hover:border-newPrimary/60"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("h4", _hoisted_78, _toDisplayString(pool.title), 1),
                            _createElementVNode("div", _hoisted_79, [
                              (pool.location)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_80, [
                                    _createVNode(_unref(MapPin), { class: "h-4 w-4 text-newPrimary" }),
                                    _createTextVNode(" " + _toDisplayString(pool.location), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (pool.type)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_81, _toDisplayString(pool.type), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("p", _hoisted_82, _toDisplayString(_unref(formatHiringTimeline)(pool.hiring_timeline, pool.timeline_date, pool.timeline)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createVNode(_unref(Briefcase), { class: "h-8 w-8 text-gray-500" })
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "text-lg font-medium text-gray-900" }, "No Active Talent Pools", -1)),
                      _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, " This company doesn't have any open talent pools right now. Check back later! ", -1))
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("section", _hoisted_86, [
                _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "border-b pb-2 text-lg font-semibold text-gray-900" }, " Company Overview ", -1)),
                _createElementVNode("div", _hoisted_87, [
                  (company.value.industry)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                        _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Industry", -1)),
                        _createElementVNode("p", _hoisted_89, _toDisplayString(company.value.industry), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(company.value.industry_attributes, (group) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: group.key
                    }, [
                      _createElementVNode("p", _hoisted_90, _toDisplayString(group.label), 1),
                      _createElementVNode("div", _hoisted_91, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.values, (value) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: value,
                            class: "rounded-full bg-gray-100 px-2.5 py-1 text-xs font-semibold text-gray-700"
                          }, _toDisplayString(value), 1))
                        }), 128))
                      ])
                    ]))
                  }), 128)),
                  (company.value.employee_size)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Employee Size", -1)),
                        _createElementVNode("p", _hoisted_93, _toDisplayString(company.value.employee_size), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (company.value.headcount_growth_12_months)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                        _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Headcount Growth (Last 12 Months)", -1)),
                        _createElementVNode("p", _hoisted_95, _toDisplayString(formatPercentValue(company.value.headcount_growth_12_months)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (company.value.average_employee_tenure)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                        _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Average Employee Tenure", -1)),
                        _createElementVNode("p", _hoisted_97, _toDisplayString(formatYearsValue(company.value.average_employee_tenure)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (cashInBankLabel.value && cashInBankDateLabel.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Cash in Bank", -1)),
                        _createElementVNode("p", _hoisted_99, _toDisplayString(cashInBankLabel.value), 1),
                        _createElementVNode("p", _hoisted_100, "As of " + _toDisplayString(cashInBankDateLabel.value), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (cashRunwayLabel.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                        _cache[15] || (_cache[15] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Cash Runway", -1)),
                        _createElementVNode("p", _hoisted_102, _toDisplayString(cashRunwayLabel.value), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (company.value.key_people.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                        _cache[16] || (_cache[16] = _createElementVNode("p", { class: "mb-1 text-xs text-gray-500" }, "Key People", -1)),
                        _createElementVNode("ul", _hoisted_104, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(company.value.key_people, (person, idx) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: idx,
                              class: "flex items-center gap-3"
                            }, [
                              _createElementVNode("div", _hoisted_105, _toDisplayString(personInitial(person)), 1),
                              _createElementVNode("div", null, [
                                _createElementVNode("p", _hoisted_106, _toDisplayString(personName(person)), 1),
                                _createElementVNode("p", _hoisted_107, _toDisplayString(personRole(person)), 1),
                                (personRoleTenure(person))
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_108, " Current Role Tenure: " + _toDisplayString(personRoleTenure(person)), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (company.value.recent_capital_raisings.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_109, [
                    _cache[19] || (_cache[19] = _createElementVNode("h3", { class: "border-b pb-2 text-lg font-semibold text-gray-900" }, "Recent Capital Raisings", -1)),
                    _createElementVNode("div", _hoisted_110, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(company.value.recent_capital_raisings, (raising, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "rounded-lg border border-border/60 bg-background/80 p-4"
                        }, [
                          _createElementVNode("div", _hoisted_111, [
                            (raising.label)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_112, _toDisplayString(raising.label), 1))
                              : _createCommentVNode("", true),
                            (raising.date)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_113, _toDisplayString(_unref(formatDateAsDayMonthYear)(raising.date)), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_114, [
                            _createElementVNode("div", _hoisted_115, [
                              (raising.amount)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_116, _toDisplayString(formatCapitalRaisingAmount(raising.amount)), 1))
                                : _createCommentVNode("", true),
                              (raising.summary)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_117, _toDisplayString(raising.summary), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (raising.url)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: normalizeExternalUrl(raising.url),
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "inline-flex shrink-0 items-center gap-1.5 text-sm font-medium text-newPrimary hover:underline"
                                }, [
                                  _cache[18] || (_cache[18] = _createTextVNode(" Source ")),
                                  _createVNode(_unref(ArrowUpRight), { class: "h-4 w-4" })
                                ], 8, _hoisted_118))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (company.value.recent_key_hires.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_119, [
                    _cache[21] || (_cache[21] = _createElementVNode("h3", { class: "border-b pb-2 text-lg font-semibold text-gray-900" }, "Executive Movements", -1)),
                    _createElementVNode("div", _hoisted_120, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(company.value.recent_key_hires, (hire, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: idx,
                          class: "rounded-lg border border-border/60 bg-background/80 p-4"
                        }, [
                          _createElementVNode("div", _hoisted_121, [
                            _createElementVNode("div", _hoisted_122, [
                              _createElementVNode("div", _hoisted_123, [
                                _createElementVNode("p", _hoisted_124, _toDisplayString(hire.name), 1),
                                (hire.date)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_125, _toDisplayString(_unref(formatDateAsDayMonthYear)(hire.date)), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (hire.role)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_126, _toDisplayString(hire.role), 1))
                                : _createCommentVNode("", true),
                              (hire.background)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_127, _toDisplayString(hire.background), 1))
                                : _createCommentVNode("", true),
                              (hire.summary)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_128, _toDisplayString(hire.summary), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (hire.url)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: normalizeExternalUrl(hire.url),
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "inline-flex shrink-0 items-center gap-1.5 text-sm font-medium text-newPrimary hover:underline"
                                }, [
                                  _cache[20] || (_cache[20] = _createTextVNode(" Source ")),
                                  _createVNode(_unref(ArrowUpRight), { class: "h-4 w-4" })
                                ], 8, _hoisted_129))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (company.value.benefits.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_130, [
                    _createElementVNode("div", _hoisted_131, [
                      _createElementVNode("div", _hoisted_132, [
                        _cache[22] || (_cache[22] = _createElementVNode("h3", { class: "text-lg font-semibold text-gray-900" }, "Benefits", -1)),
                        _createElementVNode("p", _hoisted_133, " Additional benefits and perks shared by " + _toDisplayString(company.value.name) + ". ", 1)
                      ]),
                      _createElementVNode("span", _hoisted_134, _toDisplayString(company.value.benefits.length) + " benefit" + _toDisplayString(company.value.benefits.length === 1 ? '' : 's'), 1)
                    ]),
                    _createElementVNode("div", _hoisted_135, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(company.value.benefits, (benefit, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `${benefit.heading}-${benefit.source}-${idx}`,
                          class: "rounded-lg border border-border/60 bg-background/80 p-4"
                        }, [
                          _createElementVNode("div", _hoisted_136, [
                            _createElementVNode("div", _hoisted_137, [
                              (benefit.heading)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_138, _toDisplayString(benefit.heading), 1))
                                : _createCommentVNode("", true),
                              (benefit.description)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_139, _toDisplayString(benefit.description), 1))
                                : _createCommentVNode("", true)
                            ]),
                            (benefit.source || benefit.added_at)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                                  (benefit.source)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_141, " Source: " + _toDisplayString(benefit.source), 1))
                                    : _createCommentVNode("", true),
                                  (benefit.added_at)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_142, " Added " + _toDisplayString(_unref(formatDateAsDayMonthYear)(benefit.added_at)), 1))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (socialLinkDisplayItems.value.length)
                ? (_openBlock(), _createElementBlock("section", _hoisted_143, [
                    _cache[24] || (_cache[24] = _createElementVNode("h3", { class: "border-b pb-2 text-lg font-semibold text-gray-900" }, "Social Media", -1)),
                    _createElementVNode("div", _hoisted_144, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(socialLinkDisplayItems.value, (social) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: `${social.type}-${social.url}`,
                          href: normalizeExternalUrl(social.url),
                          target: "_blank",
                          rel: "noopener noreferrer",
                          class: "group flex items-center justify-between rounded-lg border border-border/60 bg-background/80 px-4 py-3 transition hover:border-newPrimary/40 hover:bg-white"
                        }, [
                          _createElementVNode("div", _hoisted_146, [
                            _createElementVNode("p", _hoisted_147, _toDisplayString(social.label), 1),
                            _createElementVNode("p", _hoisted_148, _toDisplayString(social.displayUrl), 1)
                          ]),
                          _createElementVNode("div", _hoisted_149, [
                            _cache[23] || (_cache[23] = _createElementVNode("span", null, "Open", -1)),
                            _createVNode(_unref(ArrowUpRight), { class: "h-4 w-4 transition group-hover:translate-x-0.5 group-hover:-translate-y-0.5" })
                          ])
                        ], 8, _hoisted_145))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (operationsVisible.value)
                ? (_openBlock(), _createElementBlock("section", _hoisted_150, [
                    _cache[29] || (_cache[29] = _createElementVNode("h3", { class: "border-b pb-2 text-lg font-semibold text-gray-900" }, "On-Site Operations", -1)),
                    _createElementVNode("div", _hoisted_151, [
                      (company.value.field_roster)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                            _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Field Roster", -1)),
                            _createElementVNode("p", _hoisted_153, _toDisplayString(company.value.field_roster), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (company.value.typical_hours)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                            _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Typical Hours", -1)),
                            _createElementVNode("p", _hoisted_155, _toDisplayString(company.value.typical_hours), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (company.value.facilities)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                            _cache[27] || (_cache[27] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Facilities", -1)),
                            _createElementVNode("p", _hoisted_157, _toDisplayString(company.value.facilities), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (company.value.software_used.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                            _cache[28] || (_cache[28] = _createElementVNode("p", { class: "mb-2 text-xs text-gray-500" }, "Software Used", -1)),
                            _createElementVNode("div", _hoisted_159, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(company.value.software_used, (software) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: software,
                                  class: "rounded-full bg-gray-100 px-2.5 py-1 text-xs font-semibold text-gray-700"
                                }, _toDisplayString(software), 1))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_160, _toDisplayString(error.value || 'Company not found.'), 1))
  ]))
}
}

})